//---------------Tiered Discount function------------------//
  function cart_data_renders() {
      $.get('/cart', function(data) {
          var data = new DOMParser().parseFromString(data, 'text/html');
          document.querySelector("table.cart-items").innerHTML = data.querySelector("table.cart-items").innerHTML;
          document.querySelector("p.totals__subtotal-value").innerHTML = data.querySelector("p.totals__subtotal-value").innerHTML;
          document.querySelector(".drawer .fs__i").innerHTML = data.querySelector(".drawer .fs__i").innerHTML;
      });
  }
            function tieredDiscount() {
  $.getJSON("/cart.js", function(data) {
     // console.log(data);
      var checkGiftProduct = false;
      var checkLingerieProduct = false;
      data.items.forEach(function(p, i) {
          if (p.id == window.routes.free_gift_product) {
            //console.log("dsd");
              checkGiftProduct = true;
              if (data.total_price > 7500) {
                  if (p.quantity > 1) {
                      jQuery.post('/cart/change.js', {
                          quantity: 1,
                          id: p.key
                      }, function(ds) {
                          cart_data_renders();
                      });
                  }
              } else {
                  jQuery.post('/cart/change.js', {
                      quantity: 0,
                      id: p.key
                  }, function(ds) {
                      cart_data_renders();
                  });

              }

          } else if (p.id == window.routes.freeLingreeProduct) { 
            //console.log("sdsdd");
              if (data.total_price > 10000) {
                  checkLingerieProduct = true;
                  if (p.quantity > 1) {
                      jQuery.post('/cart/change.js', {
                          quantity: 1,
                          id: p.key
                      }, function(ds) {
                          cart_data_renders();
                      });
                  }
              } else {
                  jQuery.post('/cart/change.js', {
                      quantity: 0,
                      id: p.key
                  }, function(ds) {
                      cart_data_renders();
                  });

              }
          }
      });
      setTimeout(function() {
          //if product is not added then add gift product
          if (!checkGiftProduct && data.total_price > 7500) {
           // console.log("asasasA");
              //console.log("noooo");
              $.ajax({
                  type: "POST",
                  url: '/cart/add.json',
                  data: {
                      id: window.routes.free_gift_product,
                      quantity: 1
                  },
                  dataType: "jsonp",
                  success: function(response) {
                      // console.log(response);
                      cart_data_renders();
                  }
              });
          }
          if (!checkLingerieProduct && data.total_price > 10000) {
           // console.log("assssssssssss");
              //    console.log("noooorrr");
              $.ajax({
                  type: "POST",
                  url: '/cart/add.json',
                  data: {
                      id: window.routes.freeLingreeProduct,
                      quantity: 1
                  },
                  dataType: "jsonp",
                  success: function(response) {
                      // console.log(response);
                      cart_data_renders();
                  }
              });
          }
      }, 1000);

  });
}
  //---------Tiered Discount function end------------------- //

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
if(document.querySelector('cart-notification')){
   this.cart = document.querySelector('cart-notification');
}else{
   this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
}
      this.submitButton = this.querySelector('[type="submit"]');
     if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const event_data = evt;
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
 //          console.log("testt102");
 //          try {  console.log("testt12");
 //            $(".main-youmayalso-container-items").html("");
 //        var metaData_json = $('script.metaData_json').html().trim();
 //        var metaData = JSON.parse(metaData_json);
 //        console.log(metaData_json);
             
 //        var check = response.variant_id;
 //        if (metaData.hasOwnProperty(check)) { console.log("testt122");
 //          var value = metaData[check];
 //          console.log('Value for sdsdsd', value);
 //           $.ajax({
 //                  type: "POST",
 //                  url: '/cart/add.json',
 //                  data: {
 //                      id: value,
 //                      quantity: 1
 //                  },
 //                  dataType: "jsonp",
 //                  success: function(response) {
 //                      $.get('/cart', function(data) {
 //          var data = new DOMParser().parseFromString(data, 'text/html');
 //          document.querySelector("table.cart-items").innerHTML = data.querySelector("table.cart-items").innerHTML;
 //          document.querySelector("p.totals__subtotal-value").innerHTML = data.querySelector("p.totals__subtotal-value").innerHTML;
 //          document.querySelector(".drawer .fs__i").innerHTML = data.querySelector(".drawer .fs__i").innerHTML;
 //                         //call function  tieredDiscount(); 
 // tieredDiscount();
 //      });
 //                  }
 //              });
 //        } else {
          
 //        }
 //          } catch (error) {
            
 //          }
           
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
          // recommendations product added in cart
          $.get(`/recommendations/products?section_id=youmayalsolike&product_id=${response.product_id}&limit=10&intent=related`, function(data, status){
          $(".main-youmayalso-container-items").html(data);
          });
          })
        .catch((e) => {
          console.error(e);
        })
        .finally((f) => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          // you may also like product added in cart
      $.get(`/cart`, function(data, status){
    if(!$(".main-ajax-container").html()){
       var htmlss = $(data).find('div#CartDrawer').html();
   $("div#CartDrawer").html(htmlss);
      $.get(`/collections/recommendations?view=ajax&sort_by=manually`, function(data, status){
    var htmlss = $(data).filter('div[getHtml="true"]').html();
   $(".main-ajax-container").html(htmlss);
$("cart-drawer.drawer").removeClass("is-empty");
  });
    }else{
         var htmlss = $(data).find('div#CartDrawer').html();
   $("div#CartDrawer").html(htmlss);
      $.get(`/collections/recommendations?view=ajax&sort_by=manually`, function(data, status){
    var htmlss = $(data).filter('div[getHtml="true"]').html();
   $(".main-ajax-container").html(htmlss);
$("cart-drawer.drawer").removeClass("is-empty");
  });

    }
  });
            //call function  tieredDiscount(); 
 tieredDiscount();
if(event_data.target.attributes["data-get"] && event_data.target.attributes["data-get"].value === "ajax-cart-drawers"){
      console.log(event_data.target.attributes["data-get"].value);
$("body").addClass("off_cart_notification");
      }else{
        $("body").removeClass("off_cart_notification");
      }
        });
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
